import { render, staticRenderFns } from "./VTextAreaWithValidation.vue?vue&type=template&id=0358c018&scoped=true&"
import script from "./VTextAreaWithValidation.vue?vue&type=script&lang=js&"
export * from "./VTextAreaWithValidation.vue?vue&type=script&lang=js&"
import style0 from "./VTextAreaWithValidation.vue?vue&type=style&index=0&id=0358c018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0358c018",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
